﻿import React, { useState, useEffect, Fragment } from 'react';
import { FormRadio, FormTimePicker } from 'components/form-fields';
import { useValidation } from "hooks/useValidation";
import { ShowHide } from "components/layout";
import moment from "moment";
import PropTypes from 'prop-types';
import { HelperFunctions } from 'helpers';

export function AdditionalInfoSettings(
    {
        saving = false,
        readOnly = false,
        additionalInfoSettings,
        loading,
        onAdditionalInfoSettingsUpdate,
        onValidationUpdate,
        originalInductionTime
    }
) {

    const timeFormat = "YYYY-MM-DD HH:mm:ss";
    const inductionDateTime = "01 Jan 2000";

    const [loadingValue, setLoading] = useState(true);

    const [isValid, errors, validate] = useValidation();

    useEffect(updateValidationRules, [additionalInfoSettings]);

    function updateValidationRules() {

        const rules = [
            { fieldName: "weighPadAvailable", required: true },
            { fieldName: "inductionRequired", required: true }
        ];

        validate(rules, additionalInfoSettings.additionalInfo);
    }

    useEffect(() => {
        setLoading(loading);
    }, [loading]);


    useEffect(() => {
        HelperFunctions.executeIfNotNull(onValidationUpdate, isValid)
    }, [isValid]);


    function updateInductiontime(updateSettings) {

        if (updateSettings.inductionRequired) {
            var duration = moment(updateSettings.inductionDurationTime, timeFormat);
            updateSettings.inductionTime = (duration.hours() * 60) + duration.minutes();
        }
        else {
            updateSettings.inductionTime = 0;
            updateSettings.inductionDurationTime = moment(inductionDateTime).startOf('day').format(timeFormat);
        }
    }

    function onWeighPadAvailableChange(event) {
        HelperFunctions.executeIfNotNull(onAdditionalInfoSettingsUpdate, {
            ...additionalInfoSettings.additionalInfo,
            weighPadAvailable: event.currentTarget.value === "true"
        })
    }

    function onInductionRequired(event) {
        var inductionDurationMins = event.currentTarget.value === "true" ? additionalInfoSettings.additionalInfo.inductionDurationTime : originalInductionTime;
        var updateSettings = {
            ...additionalInfoSettings.additionalInfo,
            inductionRequired: event.currentTarget.value === "true",
            inductionDurationTime: inductionDurationMins
        }

        updateInductiontime(updateSettings);
        onAdditionalInfoSettingsUpdate(updateSettings);
    }

    function onInductionDurationTimeChange(item) {
        var inductionTime = 0;
        var inductionDurationTime = null;
        if (additionalInfoSettings.additionalInfo.inductionRequired) {
            inductionDurationTime = moment(item).format(timeFormat);
            var duration = moment(inductionDurationTime, timeFormat);
            inductionTime = (duration.hours() * 60) + duration.minutes();
        }

        var updateSettings = {
            ...additionalInfoSettings.additionalInfo,
            inductionDurationTime: inductionDurationTime,
            inductionTime: inductionTime
        }

        updateInductiontime(updateSettings);
        onAdditionalInfoSettingsUpdate(updateSettings);
    }    


    return (
        <Fragment>
            <FormRadio
                id="induction-required"
                disabled={readOnly || saving}
                onChange={onInductionRequired}
                headingText="Is an induction required?"
                selectedValue={additionalInfoSettings.additionalInfo.inductionRequired}
                dangerHelperText={errors.inductionRequired}
                loading={loadingValue}
            ></FormRadio>
            <ShowHide
                evaluator={additionalInfoSettings !== undefined && additionalInfoSettings.additionalInfo.inductionRequired}
                show={(
                    <Fragment>
                        <div className="spacer-bottom">
                            <FormTimePicker
                                disabled={readOnly || saving || !additionalInfoSettings.additionalInfo.inductionRequired}
                                value={additionalInfoSettings.additionalInfo.inductionDurationTime}
                                onChange={onInductionDurationTimeChange}
                                headingText="How long will the induction take?"
                                dangerHelperText={errors.inductionDurationMins}
                                loading={loadingValue}
                                id="input-induction-duration-mins"
                            ></FormTimePicker>
                        </div>
                    </Fragment>
                )}
            ></ShowHide>
            <FormRadio
                id="weigh-pad-available"
                disabled={readOnly || saving}
                onChange={onWeighPadAvailableChange}
                headingText="Please advise if there a weigh pad onsite if vehicles are being inspected by Logistics UK"
                selectedValue={additionalInfoSettings.additionalInfo.weighPadAvailable}
                dangerHelperText={errors.weighPadAvailable}
                loading={loadingValue}
            ></FormRadio>
        </Fragment >
    );
}

AdditionalInfoSettings.propTypes = {
    additionalInfoSettings: PropTypes.object.isRequired,
    originalInductionTime: PropTypes.string,
    saving: PropTypes.bool,
    loading: PropTypes.bool.isRequired,
    readOnly: PropTypes.bool
};